export default __webpack_public_path__ + "static/img/collections-men-accessories-bg.c08eee2.jpg";